/* =========================================================
   Three Simple Steps — reveal + connector + hover sync
   ========================================================= */

(function () {
  'use strict';

  function initSteps(root) {
    if (!root || root.dataset.stepsInit === 'true') return;
    root.dataset.stepsInit = 'true';

    // ---------- Reveal on scroll ----------
    const revealEls = root.querySelectorAll('.reveal');
    const grid = root.querySelector('.steps__grid');

    if ('IntersectionObserver' in window) {
      if (revealEls.length) {
        const io = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              if (entry.isIntersecting) {
                entry.target.classList.add('in');
                io.unobserve(entry.target);
              }
            });
          },
          {
            threshold: 0.15,
            rootMargin: '0px 0px -60px 0px',
          }
        );
        revealEls.forEach((el) => io.observe(el));
      }

      // Trigger connector fill when grid enters view
      if (grid) {
        const gridIO = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              if (entry.isIntersecting) {
                setTimeout(() => grid.classList.add('is-active'), 300);
                gridIO.unobserve(entry.target);
              }
            });
          },
          { threshold: 0.35 }
        );
        gridIO.observe(grid);
      }
    } else {
      revealEls.forEach((el) => el.classList.add('in'));
      if (grid) grid.classList.add('is-active');
    }

    // ---------- Hover sync: connector fills up to hovered step ----------
    const cards = root.querySelectorAll('.steps__card');
    const connector = root.querySelector('[data-connector-fill]');
    const cardCount = cards.length;

    if (connector && cardCount > 1) {
      cards.forEach((card) => {
        card.addEventListener('mouseenter', () => {
          if (!grid.classList.contains('is-active')) return;
          const idx = parseInt(card.dataset.stepIndex, 10);
          const pct = ((idx + 0.5) / cardCount) * 100;
          connector.style.transition = 'width 0.5s cubic-bezier(0.22, 1, 0.36, 1)';
          connector.style.width = `${pct}%`;
        });

        card.addEventListener('mouseleave', () => {
          connector.style.width = '100%';
        });
      });
    }
  }

  function initAll() {
    document.querySelectorAll('.steps[data-section-id]').forEach(initSteps);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  // Shopify theme editor support
  document.addEventListener('shopify:section:load', (e) => {
    const root = e.target.querySelector('.steps[data-section-id]');
    if (root) initSteps(root);
  });

  document.addEventListener('shopify:section:unload', (e) => {
    const root = e.target.querySelector('.steps[data-section-id]');
    if (root) root.dataset.stepsInit = '';
  });
})();
